import { PlaceholderInspector } from "./PlaceholderInspector"
import type { ControlInspector } from "./types"

export const singleLineText: ControlInspector<"singleLineText"> = {
  Inspector: ({ field, onEdit }) => (
    <PlaceholderInspector placeholder={field.placeholder} onEdit={onEdit} />
  ),
}
